// id.<root> anonymous state — the unified SSO front door. Unlike id-online
// (which auto-redirects unauthenticated users straight into B2C), the identity
// surface presents the choice: sign in, step up with 2FA, or create an account.
// Each action is a full hand-off to a B2C journey on THIS host (same-origin
// with the IdP) via the adapter's /auth/login?flow=… — the same endpoint
// altersvorsorge + signin-mfa already use.

import { authClient } from "../lib/auth";
import { brandLabel, resolveBrand, resolveTenant, surfaceUrl } from "../lib/brand";

export function Landing() {
  const brand = resolveBrand();
  const tenant = resolveTenant();
  const label = brandLabel(tenant);
  // Return to wherever the app is actually served after the B2C round-trip —
  // host-agnostic so this works on the interim account.<root> preview host AND
  // on the eventual id.<root> go-live without a code change.
  const idHome = window.location.origin + "/";

  return (
    <>
      <header className="hub-page-header">
        <h1>{label} identity</h1>
        <p>
          One sign-in for your {label} account. Authentication runs on this
          domain against Azure AD B2C; your account and depots live in the{" "}
          {label} core.
        </p>
      </header>
      <main className="hub-cta-row">
        <button
          type="button"
          className="hub-cta-button"
          data-id-signin
          onClick={() =>
            authClient.loginRedirect({ brand, flow: "signin", return: idHome })
          }
        >
          Sign in
        </button>
        <button
          type="button"
          className="hub-cta-button secondary"
          data-id-signin-mfa
          onClick={() =>
            authClient.loginRedirect({ brand, flow: "signin-mfa", return: idHome })
          }
        >
          Sign in with 2FA
        </button>
        <a
          className="hub-cta-button secondary"
          href={surfaceUrl("altersvorsorge", tenant) + "/"}
          data-id-create
        >
          Create an account
        </a>
      </main>
    </>
  );
}
